import { Button, styled, darken } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary500,
  color: theme.palette.neutral900,
  '&:hover': {
    backgroundColor: darken(theme.palette.secondary500, 0.2),
  },
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.neutral400} !important`,
    color: theme.palette.neutral000,
  },
  '& .MuiButton-endIcon': {
    margin: 0,
    '& > svg': {
      fontSize: '24px',
    },
  },
}))

export const SecondaryButton = createWithLoadingButton(StyledButton)
